export default __webpack_public_path__ + "static/media/wembley.64cd2ef6.webp";